import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import * as $ from 'jquery';

@Component({
  selector: 'app-noticieros',
  templateUrl: './noticieros.component.html',
  styleUrls: ['./noticieros.component.scss']
})
export class NoticierosComponent implements OnInit {

  constructor(private titleService: Title, private route: Router,) {
    this.titleService.setTitle("REPORTAJE Y PROPAGANDA: NOTICIAROS CINEMATOGRÁFICOS PERUANOS DE LOS 40");
  }

  ngOnInit(): void {
    $("a").click(function() {
        if($(this).hasClass('video3')){
          var idcaja = $(this).attr("id");
          var idvideo = $("#"+idcaja+" img").attr("src").split("/")[4];
          var ytvideo = "<iframe src='https://www.youtube.com/embed/" + idvideo + "?rel=0&autoplay=1' allow='autoplay;' frameborder='0' allowfullscreen style='top: 0;bottom: 0;margin: auto;width: 100%; height:100%;'></iframe>";
          $("#"+idcaja).addClass("vacio");
          document.getElementById($(this).attr("id")).innerHTML = ytvideo;
        }
      });
  }

}
